"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Model_1 = __importDefault(require("../Model"));
var Content_1 = require("../Content");
var array_1 = require("../../helpers/array");
var QuestionModel = /** @class */ (function (_super) {
    __extends(QuestionModel, _super);
    function QuestionModel(question, getters) {
        var _this = _super.call(this, getters) || this;
        _this.id = question.id;
        _this.mode = question.mode || '';
        _this.answered = question.answered !== undefined ? question.answered : null;
        _this.title = question.title;
        _this.slug = question.slug;
        _this.averageScore = question.averageScore;
        _this.answer = question.answer;
        _this.source = question.source || {};
        _this.alternatives = question.alternatives;
        _this.interactiveData = question.interactiveData;
        _this.group = question.group;
        _this.examApplicationId = question.examApplicationId;
        _this.examModeId = question.examModeByExamModeId || question.examModeId;
        _this.tags = question.tags;
        _this.distinctUserReplies = question.distinctUserReplies;
        return _this;
    }
    // We are not accepting discursive questions yet, so the difference between a 'discursive'
    // question and an objective question is the number of assertions. Discursive questions are
    // represented by an objective question with a single assertion 'Insert your answer'.
    QuestionModel.prototype.isObjective = function () {
        var objectiveMode = ['objective', 'binary', 'multibinary'];
        return objectiveMode.includes(this.mode) || this.assertions.length > 1;
    };
    QuestionModel.prototype.isDiscursive = function () {
        var discursiveMode = ['formula', 'essay', 'discursive'];
        return discursiveMode.includes(this.mode) && this.assertions.length <= 1;
    };
    QuestionModel.prototype.isPractice = function () {
        var practiceMode = ['practice'];
        return practiceMode.includes(this.mode) && this.assertions.length <= 1;
    };
    Object.defineProperty(QuestionModel.prototype, "difficulty", {
        get: function () {
            if (!this.averageScore)
                return null;
            if (this.averageScore >= 0.75)
                return 'Fácil';
            if (this.averageScore >= 0.5)
                return 'Média';
            return 'Difícil';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionModel.prototype, "assertions", {
        get: function () {
            return this.getters
                .assertionsByQuestionId(this.id)
                .concat()
                .sort(array_1.positionAscending);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionModel.prototype, "contents", {
        get: function () {
            return this.getters
                .contentsByQuestionId(this.id)
                .concat()
                .sort(array_1.positionAscending);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionModel.prototype, "examApplications", {
        get: function () {
            return this.getters
                .questionApplicationsByQuestionId(this.id)
                .map(function (questionApplication) { return questionApplication.examApplication; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionModel.prototype, "knowledges", {
        get: function () {
            return this.getters
                .knowledgeAssociationsByQuestionId(this.id)
                .map(function (knowledgeAssociation) { return knowledgeAssociation.knowledge; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionModel.prototype, "replies", {
        get: function () {
            return this.getters.repliesByQuestionId(this.id);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionModel.prototype, "solutions", {
        get: function () {
            return this.getters
                .solutionsByQuestionId(this.id)
                .concat()
                .sort(array_1.positionAscending);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionModel.prototype, "comments", {
        get: function () {
            return this.getters
                .commentsByQuestionId(this.id)
                .concat()
                .sort(array_1.positionAscending);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionModel.prototype, "currentUserComments", {
        get: function () {
            var currentUserId = this.getters.currentUser.id;
            return this.comments.filter(function (comment) { return comment.userId === currentUserId; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionModel.prototype, "lists", {
        get: function () {
            return this.getters.listItemsByQuestionId(this.id).map(function (listItem) { return listItem.list; });
        },
        enumerable: true,
        configurable: true
    });
    QuestionModel.prototype.legacyContent = function () {
        return Content_1.ContentModel.buildLegacyContent(this.contents);
    };
    QuestionModel.prototype.legacyInteractiveData = function () {
        return {
            alternatives: this.assertions.map(function (assertion) { return assertion.legacyContent(); }),
        };
    };
    QuestionModel.prototype.computedAnswer = function () {
        var correctAssertion = this.assertions.find(function (assertion) { return assertion.correct; });
        if (correctAssertion) {
            return String(correctAssertion.position);
        }
        else {
            return this.answer;
        }
    };
    QuestionModel.prototype.raw = function () {
        return {
            id: this.id,
            title: this.title,
            content: this.legacyContent(),
            examModeId: this.examModeId,
            answer: this.computedAnswer(),
            source: this.source,
            mode: this.mode,
            alternatives: this.alternatives,
            interactiveData: this.legacyInteractiveData(),
            group: this.group,
            tags: this.tags,
            examApplicationId: this.examApplicationId,
            __typename: QuestionModel.__typename,
        };
    };
    QuestionModel.__typename = 'Question';
    return QuestionModel;
}(Model_1.default));
exports.QuestionModel = QuestionModel;
